import { Grid, Paper, Typography, Box } from '@mui/material';
import React from 'react';
import { Link } from 'react-router-dom';
import { SERVICE_CONTAINER } from '../../shared/Strings';
import { IconContainer } from '../IconContainer/IconContainer';

export const ServiceContainer = ({
  title,
  items,
  viewAllButton,
  viewAllRoute,
}) => {
  return (
    <Paper
      elevation={2}
      sx={{
        bgcolor: 'paper.main',
        borderRadius: '12px',
      }}>
      <Box sx={{ p: 2 }}>
        <Grid
          container
          spacing={3}
          direction="column"
          justifyContent="flex-start">
          <Grid
            item
            sx={{
              display: 'flex',
              justifyContent: 'left',
              position: 'relative',
            }}>
            <Typography variant="nav" sx={{ color: 'black' }}>
              {title}
            </Typography>
            {viewAllButton && (
              <Typography
                component={Link}
                to={viewAllRoute}
                variant="h6"
                sx={{
                  position: 'absolute',
                  top: 24,
                  right: 10,
                  textDecoration: 'none',
                  color: 'primary.main',
                }}>
                {SERVICE_CONTAINER.VIEW_ALL}
              </Typography>
            )}
          </Grid>
          <Grid item>
            <Grid container spacing={2} sx={{ justifyContent: 'left' }}>
              {items.map(item => (
                <Grid item key={item.id}>
                  <IconContainer
                    route={item.route}
                    imgUrl={item.icon}
                    caption={item.category}
                    origin={'service'}
                  />
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Paper>
  );
};
